"use client";

import React, { useState } from "react";
import Link from "next/link";
import Image from "next/image";
import styles from "../styles/components/Header.module.scss";

import {
  FaFacebookF,
  FaInstagram,
  FaLinkedinIn,
  FaYoutube,
} from "react-icons/fa";

import { IoMdCall } from "react-icons/io";

import BookNowButton from "./BestDeal/BookNowButton";
import { usePathname } from "next/navigation";
import { IconsCurrency, IconsGlobe } from "./Icons/Icons";

/* =========================
   Header
========================= */
const Header = () => {
  const [isactive, setIsactive] = useState(false);

  const pathname = usePathname();

  const searchResult = pathname === "/searchresult";

  const checkout = pathname === "/searchresult/checkout";

  /* =========================
     Mobile menu toggle
  ========================== */

  const handleIsActive = () => {
    setIsactive(!isactive);
  };
  const menu = [
    { name: "About Us", link: "/about-us" },
    { name: "Rooms & Suites", link: "/hotel-room-in-shimla" },
    { name: "Dining", link: "/bar-and-restaurant" },
    { name: "Adventure", link: "https://www.adventureresortkufri.com" },
    {
      name: "Events",
      dropdown: [
        ["Wedding", "/banquet-halls-in-shimla"],
        ["Meetings", "/conference-hall"],
      ],
    },
    { name: "Experiences", link: "/experiences" },
  ];
  const mobileMenu = [
    ["About Us", "/about-us"],
    ["Rooms & Suites", "/hotel-room-in-shimla"],
    ["Dining", "/bar-and-restaurant"],
    ["Adventure", "https://www.adventureresortkufri.com"],
    ["Wedding", "/banquet-halls-in-shimla"],
    ["Meetings", "/conference-hall"],
    ["Experiences", "/experiences"],
    ["Gallery", "/gallery"],
    ["Contact Us", "/contact-us"],
  ];
  return (
    <>
      {/* =========================
          DESKTOP HEADER
      ========================== */}

      <header className={styles.header}>
        <div className={`${styles.header_bottom} w-100`}>
          <div className={styles.header_container}>
            <div className={styles.header_flex}>
              {/* =========================
                  DESKTOP LOGO
              ========================== */}

              <div className={styles.logo}>
                <Link href="/">
                  <Image
                    src="/icons/logo.svg"
                    width={240}
                    height={55}
                    alt="Twin-Tower Logo"
                    loading="eager"
                  />
                </Link>
              </div>

              {/* =========================
                  MOBILE LOGO
              ========================== */}

              <div className={styles.mobile_logo}>
                <Link href="/">
                  <Image
                    src="/icons/mobile-logotwo.png"
                    width={200}
                    height={53}
                    alt="Logo"
                  />
                </Link>
              </div>

              {/* =========================
                  NAVIGATION
              ========================== */}

              <div className={styles.header_right}>
                <nav className={`${styles.navbar} navbar-expand-lg`}>
                  <div className="navbar-collapse" id="navbarNav">
                    <ul className={styles.navbar_nav}>
                      {menu.map((item) => (
                        <li
                          key={item.name}
                          className={`${styles.nav_item} ${item.dropdown ? styles.dropdown : ""}`}
                        >
                          {item.dropdown ? (
                            <>
                              <span className={styles.nav_link}>
                                {item.name}{" "}
                                <span className={styles.dropdown_icon}>▼</span>
                              </span>

                              <ul className={styles.dropdown_menu}>
                                {item.dropdown.map(([name, link]) => (
                                  <li key={name}>
                                    <Link
                                      href={link}
                                      className={styles.drop_down_nav_link}
                                    >
                                      {name}
                                    </Link>
                                  </li>
                                ))}
                              </ul>
                            </>
                          ) : (
                            <Link href={item.link} className={styles.nav_link}>
                              {item.name}
                            </Link>
                          )}
                        </li>
                      ))}
                    </ul>
                  </div>
                </nav>
              </div>

              {/* =========================
                  RIGHT SIDE
              ========================== */}

              <div className={styles.header_right_btn}>
                {/* Call */}

                <div>
                  <Link href="tel:9318192605" className={styles.call_icon}>
                    <IoMdCall className={styles.call_react_icon} />

                    <p>CALL US</p>
                  </Link>
                </div>

                {/* Book Now */}

                <div>
                  <BookNowButton />
                </div>

                {/* Locale */}

                {(searchResult || checkout) && (
                  <div className={styles.header_locale_card}>
                    {/* Language */}

                    <div className={styles.header_locale_item}>
                      <span className={styles.header_locale_icon}>
                        <IconsGlobe />
                      </span>

                      <span className={styles.header_locale_label}>EN</span>
                    </div>

                    <div className={styles.header_locale_divider} />

                    {/* Currency */}

                    <div className={styles.header_locale_item}>
                      <span className={styles.header_locale_icon}>
                        <IconsCurrency />
                      </span>

                      <span className={styles.header_locale_label}>INR</span>
                    </div>
                  </div>
                )}
              </div>

              {/* =========================
                  MOBILE MENU BUTTON
              ========================== */}

              <button
                onClick={handleIsActive}
                className={styles.header_toggle}
                aria-label="Open mobile menu"
              >
                <Image
                  src="/icons/menu.svg"
                  width={20}
                  height={20}
                  alt="Menu"
                />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* =========================
          MOBILE HEADER
      ========================== */}

      {isactive ? (
        <header className={styles.header_trans}>
          <div className={styles.mobile_header}>
            <div className="container">
              <div className={styles.mobile_header_div}>
                {/* Mobile Logo */}

                <div className="logo">
                  <Link className={styles.navbar_brand} href="/">
                    <Image
                      src="/icons/mobile-logotwo.png"
                      width={200}
                      height={50}
                      alt="Twin-Tower Logo"
                    />
                  </Link>
                </div>

                {/* Close Button */}

                <div>
                  <button
                    className={styles.navbar_cut_btn}
                    onClick={handleIsActive}
                    aria-label="Close mobile menu"
                  >
                    <Image
                      src="/icons/close.svg"
                      width={18}
                      height={18}
                      alt="Close"
                    />
                  </button>
                </div>
              </div>

              {/* Mobile Navigation */}

              <div>
                <nav>
                  <div>
                    <div className={styles.res_header_links}>
                      <ul className={styles.mobile_view_ul}>
                        {mobileMenu.map(([name, link]) => (
                          <li key={name} className={styles.mobile_view_lists}>
                            {link.startsWith("http") ? (
                              <a
                                href={link}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {name}
                              </a>
                            ) : (
                              <Link href={link} onClick={handleIsActive}>
                                {name}
                              </Link>
                            )}
                          </li>
                        ))}
                      </ul>
                    </div>

                    {/* Mobile buttons */}

                    <div className={styles.header_right_btn}>
                      <BookNowButton setIsactive={setIsactive} />

                      <Link href="tel:9318192605" className={styles.call_icon}>
                        <Image
                          src="/icons/header-call.svg"
                          width={20}
                          height={20}
                          alt="Call Icon"
                        />

                        <p>Call Us</p>
                      </Link>
                    </div>
                  </div>
                </nav>

                {/* =========================
                    SOCIAL LINKS
                ========================== */}

                <div className={styles.contact_social_links}>
                  {/* Facebook */}

                  <div className={styles.icon}>
                    <Link
                      className={styles.fb}
                      href="https://www.facebook.com/twintower.hotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaFacebookF />
                    </Link>
                  </div>

                  {/* Instagram */}

                  <div className={styles.icon}>
                    <Link
                      href="https://www.instagram.com/hotel_twintowers"
                      className={styles.insta}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaInstagram />
                    </Link>
                  </div>

                  {/* LinkedIn */}

                  <div className={styles.icon}>
                    <Link
                      className={styles.linkedin}
                      href="https://www.linkedin.com/in/the-twin-towers-hotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaLinkedinIn />
                    </Link>
                  </div>

                  {/* YouTube */}

                  <div className={styles.icon}>
                    <Link
                      className={styles.linkedin}
                      href="https://www.youtube.com/@thetwintowershotel"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <FaYoutube />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
      ) : null}
    </>
  );
};

export default Header;
